export default __webpack_public_path__ + "static/media/Poppins-SemiBold.090bd619.ttf";